/**
 * Home Hero Carousel (Flickity)
 *
 * @author Dylan James Wagner
 */
const Flickity = require('flickity');

function init() {
  const carousel = document.querySelectorAll('.homepage-hero__carousel');

  if (carousel.length) {

    for (let i = 0; i < carousel.length; i++) {

      const flkty = new Flickity(carousel[i], {
        autoPlay: true,              // Default false, true = 3s
        // wrapAround: true,            // Default false
        pageDots: false,             // Default true
        groupCells: true,            // Default false
        // groupCells: '100%',          // Default ???
        // cellAlign: 'left',           // Default center
        // contain: true,               // Default false
        // prevNextButtons: false,      // Default true
        // pauseAutoPlayOnHover: false, // Default true
        // selectedAttraction: 0.01,    // Default ???
        // friction: 0.15,              // Default ???
        // adaptiveHeight: true,        // Default false
        // watchCSS: true,              // Default false
        // imagesLoaded: true,          // Default false, requires npm flickity-imagesloaded
        // fullscreen: true,            // Default false, requires npm flickity-fullscreen
        // arrowShape: {
        //   x0: 10,
        //   x1: 60, y1: 50,
        //   x2: 70, y2: 40,
        //   x3: 30
        // },
      });

      flkty.resize(); /** Sarfari height */

      /**
       * Resize cells
       *
       * @link https://flickity.metafizzy.co/extras.html
       * @link https://codepen.io/desandro/pen/ZXEGVq
       */
      // Flickity.prototype._createResizeClass = function() {
      //   this.element.classList.add('flickity-resize');
      // };
      //
      // Flickity.createMethods.push('_createResizeClass');
      //
      // var resize = Flickity.prototype.resize;
      // Flickity.prototype.resize = function() {
      //   this.element.classList.remove('flickity-resize');
      //   resize.call( this );
      //   this.element.classList.add('flickity-resize');
      // };
    }
  }
}

export {init as default};
